import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getInventoryLocationMenuItems } from './helpers'

const InventoryLocationSelector = ({ inventoryLocations, value, onChange, usedInventoryLocationIds }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Ubicación de inventario')}
      value={value}
      handleChange={e => onChange(e.target.value)}
      menuItems={getInventoryLocationMenuItems(inventoryLocations, usedInventoryLocationIds, value)}
      fullWidth
    />
  )
}

export default InventoryLocationSelector
